import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import './ActiveList.css';
import { ServicegetCommunication, ServiceResendSMS } from "../Services/Service";
import 'jquery/dist/jquery.min.js';
import Table from './DataTable/DataTable';
import { CustomLoader, ModalBox } from "../Services/CommonLibrary";
import { DateRangeComp } from './DatePicker/CustomRangeDatePicker';

const queryParams = new URLSearchParams(window.location.search);
const status = queryParams.get('status');

function CommunicationTextPatients() {

    const clickhandler = name => console.log("delete", name);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const startIndex = (currentPage - 1) * 50;

    const [serviceData, setServiceData] = useState([]);
    var storage= JSON.parse(localStorage.getItem('programDetail')) ? JSON.parse(localStorage.getItem('programDetail')) : 0;
    let programId = storage.programId;
    const nav = useNavigate();
    const accessFrom= localStorage.getItem('access');
    let limit ='';
    const dropStatus = [
        { value: 'onboarded', label: 'Onboarded' },
        { value: 'reminder1', label: 'Reminder 1' },
        { value: 'reminder2', label: 'Reminder 2' },
        { value: 'reminder3', label: 'Reminder 3' },
    ];

    const [showModal, setShowModal] = useState(false);
    const handleClose = () =>setShowModal(false);
    
    const [encId, setEncId] = useState('');


    useEffect(() => {
        fetchProgramDetails('onboarded');
    }, []);

    const fetchProgramDetails = async (filterStatus) => {
        // if (accessFrom!='superadmin') {
        //     return nav('/upload');      
        //   }
          ServicegetCommunication(filterStatus)
            .then((res) => {
                setServiceData(res.data.data.communicationlist);
                setLoading(false);
            });
    }

   
    const columns = [
        {name: "#",cell: (row, index) => startIndex+index + 1,sortable: false,grow: 0},
        {name: "Mobile",selector: row => row.mobile,sortable: true,grow: 1},
        {name: "SMS Text",cell: (row) => <div className="text-wrap">{row.smsText}</div>,sortable: true,grow: 4,style: { 'whiteSpace': 'unset' }},
        {name: "Status",selector: row => row.status,sortable: true,grow: 1,
            conditionalCellStyles: [
                {
                    when: row => row.status ==  'delivered',
                    style: {color: 'green',textTransform: 'capitalize'},
                },
                {
                    when: row => row.status ==  'Undelivered',
                    style: {color: 'red',textTransform: 'capitalize'},
                },
                {
                    when: row => row.status ==  'undelivered',
                    style: {color: 'red',textTransform: 'capitalize'},
                },
                {
                    when: row => row.status ==  'Failed',
                    style: {color: 'red',textTransform: 'capitalize'},
                },
            ],
        },
        {name: "Sent Date",selector: row => row.createdTime,sortable: true,grow: 2},
        {
            name: "Action", //Consultation Notes
            button: true,
            omit: (accessFrom=='superadmin' || accessFrom=='admin') ? false : true ,
            cell: row =>
                <button className='btn btn-primary btn-sm btn-edit' onClick={(e)=>viewPopup(row.enc_id)}>Resend</button>
                
          }
      ];
    
      const onValueChange = (e) =>
      {
          
          if(e.target.id=='filterStatus'){
            setLoading(true);
            fetchProgramDetails(e.target.value);
          }
  
      }
    const viewPopup=(enc_id)=>{
        setEncId('');
        setEncId(enc_id);
        setShowModal(true);
    }

    const resendSms = async (filterStatus) => {
        setLoading(true);
          ServiceResendSMS(encId)
            .then((res) => {
                setEncId('');
                setLoading(false);
                handleClose();
            });
    }  

    const modalBodyComponent=<><span>Are You sure? <br/><br/> <button className='btn btn-primary' onClick={resendSms}>Yes</button> <button className='btn btn-secondary' onClick={handleClose}>No</button></span></>;
    const DataTableTitle = <>
                                
                                <div className="row mb-3 align-items-center">
                                    <div className="col-md-9">
                                        <h1 className="title">Communication</h1>
                                    </div>
                                    <div className="col-md-12">
                                        {/* <div className="form-floating">
                                            <select className="form-control" style={{"height": "36px","padding": "0 0 0 25px", width:'150px'}} required name="filterStatus" id="filterStatus" onChange={(e) => onValueChange(e)} >
                                                {dropStatus.map((dropStatus,i) => (
                                                    <option value={dropStatus.value} key={i}>{dropStatus.label}</option>
                                                ))}
                                            </select>
                                        </div> */}
                                        {/* <button type="button"  className="btn btn-success btn-sm" >Send Reminder to 4033 Patients</button> */}
                                    </div>
                                    
                                </div>
                            </>
    const onChangePage=(page)=>{
        setCurrentPage(page);
    }
    return (

        <section className=''>


    

            {/* <div className="row mb-5 mt-3 pb-3">
                <div className="col-md-12">
                    <h1 className="title">Send communication to patients</h1>
                    <h4 className="mt-1 mb-1">Who will receive this message</h4>
                </div>
                <div className='col-md-9'>
                    <div className='row mt-3'>
                        <div className='col-md-auto pe-0'>
                            <DateRangeComp  /> 
                        </div>
                        <div className="col-md pe-0">
                            <select  id="programSelect" name="programSelect"  value="" className='form-select form-select-sm' required >
                                <option value="">Select Status</option>
                            </select>
                        </div>
                        <div className="col-md pe-0">
                            <select  id="programSelect" name="programSelect"  value="" className='form-select form-select-sm' required >
                                <option value="">Select Practice</option>
                            </select>
                        </div>
                        <div className="col-md pe-0">
                            <select  id="programSelect" name="programSelect"  value="" className='form-select form-select-sm' required >
                                <option value="">Select Division</option>
                            </select>
                        </div>
                        
                    </div>
                    <div className='row mt-3'>
                        <div className='col-md-6 pe-0'>
                                <div className="card">
                                    <div className="card-body px-3 pt-2 pb-3">
                                            <h6 className="mb-2">Select Communication Channel</h6>
                                            <div className="form-check-inline">
                                            <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                                            <label className="form-check-label ps-2" htmlFor="inlineCheckbox1"> WhatsApp</label>
                                            </div>
                                            <div className="form-check-inline">
                                            <input className="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2"/>
                                            <label className="form-check-label ps-2" htmlFor='inlineCheckbox2'> SMS</label>
                                            </div>
                                    </div>
                                </div>
                        </div>
                        <div className='col-md-6 pe-0'>
                            <div className="card">
                                    <div className="card-body px-3 py-2">
                                            <h6 className="mb-1">Select Communication Channel</h6>
                                            <select  id="programSelect" name="programSelect" value="" className='form-select form-select-sm' required >
                                                <option value="">Reminder Message</option>
                                            </select>
                                    </div>
                                </div>
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <div className='col-md-auto'>
                            <button type="button"  className="btn btn-success btn-sm" >Clear</button>
                        </div>
                    </div>
                </div>
                <div className='col-md-3 mt-3'>
                    <div style={{width: '100%', backgroundColor: '#e3dad2', maxHeight: '168px', border: '3px solid rgb(17, 21, 21)', padding: '10px',borderRadius: '20px', overflowY:"scroll"}}>
                        <div>
                        <div className="card">
                            <div className="card-body px-3 py-2">
                                <p style={{fontSize:'12px', lineHeight:'1.3'}}>
                                Dear Ills. This is just. reminder. We have referred vot to our specialist coaching successfully created fol Modality's ((2)). Start your journey now by downloading the App and login using you regIstered mop up XXXXXX ((3))
                                </p>
                                <p className='mt-1' style={{fontSize:'12px', fontWeight:'600', color:'#787878'}}>
                                #BETHEFORCE
                                </p>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                
            </div> */}

            <div className='row'>
                
                <div className="FL">
                    <div className='table-responsive'>
                        <Table data={serviceData} column={columns} title={DataTableTitle} showFilter="true" click={clickhandler} onChangePage={onChangePage} showTemplate="true" showSendBtn="true" filterStatus='true' filterPractice='true' filterDivision='true' filterSmsDate='true' showClearbtn="true" />
                    </div>
                </div>
            </div>
            { loading ? <CustomLoader /> : null }
            {showModal?<ModalBox handleClose={handleClose} showModaln={showModal} titlen="Alert" bodyn={modalBodyComponent}/>: ''}
        </section>

        // <section className='projects-section'>
        //      <div className='row'>
        //         <div className="FL">
        //             <div className='table-responsive'>
        //                 <Table data={serviceData} column={columns} title={'Communication'} click={clickhandler} />
        //             </div>
        //         </div>
        //     </div>
        //     { loading ? <CustomLoader /> : null }
        // </section>

    );
}
export default CommunicationTextPatients;